import React, { FC, memo, useEffect } from 'react';
import 'whatwg-fetch';
import TopBar from './TopBar';
import { LegacyUser } from 'src/interfaces/api/User';
import { useRecoilState } from 'recoil';
import useEmployeeAccess from 'src/hooks/api/useEmployeeAccess';
import employeesState from 'src/recoil/atoms/employees';

interface Props {
  history?: any;
  user?: LegacyUser;
}

const TopBarContainer: FC<Props> = ({ history, user }) => {
  const [, setEmployees] = useRecoilState(employeesState);
  const { me } = useEmployeeAccess();

  useEffect(() => {
    me().then((employee) => {
      setEmployees((employees) => Object.assign({}, employees, { [employee.id]: employee }));
    });
  }, [user]);

  return <TopBar user={user} history={history} />;
};

export default memo(TopBarContainer, (prevProps, nextProps) => prevProps.user?.id === nextProps.user?.id);
